import type {ActionDefinition, ActionDefinitionObject} from '../types/ActionDefinition';
import type {RowData} from '../types/RowData';

export type BulkActionEntry = {
  actionKey: string;
  definition: ActionDefinition;
  rowIds: string[];
};

/**
 * Derives the bulk actions available across the currently loaded rows: for every
 * definition flagged `bulkAction`, the ids of loaded rows whose primary/secondary
 * action keys include it. Union-with-count semantics (a key present on ANY row),
 * distinct from the native bulk bar's intersection over SELECTED rows. Every
 * bulkAction-flagged definition yields an entry — with `rowIds: []` when no loaded
 * row carries it — so hosts can render the full catalog with zero counts.
 */
export const getBulkActionsFromRows = (
  rows: RowData[],
  actionsDefinition: ActionDefinitionObject
): BulkActionEntry[] =>
  Object.entries(actionsDefinition)
    .filter(([, definition]) => definition.bulkAction)
    .map(([actionKey, definition]) => ({
      actionKey,
      definition,
      rowIds: rows
        .filter(
          (row) =>
            row.actions.primary.includes(actionKey) || row.actions.secondary.includes(actionKey)
        )
        .map((row) => row.id),
    }));
